module.exports = __webpack_public_path__ + "static/media/logos_google-analytics.59e21b2b.svg";